import {fetchAndUpdateFileLockState} from 'notebook/realtime/DocumentEditorLockReduxActions';
import {displayNotification} from 'notebook/realtime/DocumentUpdateNotifications';
import {RealtimeMessageType} from 'realtime/Constants';

import type {DocumentUpdateMessageHandler} from './DocumentUpdateMessageHandlerConstants';

export const lockUpdateMessageHandler: DocumentUpdateMessageHandler<typeof RealtimeMessageType.LOCK_UPDATE> =
  {
    active: (fileId, {lock, userNotifications}) => {
      if (userNotifications) {
        for (const notification of userNotifications) {
          displayNotification(notification);
        }
      }
      fetchAndUpdateFileLockState(fileId, lock);
    },
  };
